import Page from '../../classes/Page'
import { app } from '../../utils/store'

import { getCookie } from '../../utils/cookies'

export default class Catalogues extends Page{
    constructor(){
        super({
            id : 'catalogues',
            element: '[data-app-page]',
            elements: { 
                wrapper: '#results',
                permission: 'div[data-permission]'
            }
        })

        this.url = new URL(window.location.href)
    }

    create() {
        super.create()

        let permission = getCookie('catalogue_download') === 'active'
        let force = this.url.searchParams.get('force')

        if(force){ permission = force === 'alsjhdasa' }

        if(this.elements.permission){
            let contents = {
                false: document.querySelectorAll('[data-permission="false"]'),
                true: document.querySelectorAll('[data-permission="true"]'),
            }

            if(!permission){
                contents.false.forEach(entry => entry.style.display = 'block')
                contents.true.forEach(entry => {
                    entry.style.display = 'none'
                    entry.parentNode.removeChild(entry)
                })
            } else {
                contents.false.forEach(entry => {
                    entry.style.display = 'none'
                    entry.parentNode.removeChild(entry)
                })
                contents.true.forEach(entry => entry.style.display = 'block')
            }
        }

        this.filterCatalogues()
    }

    filterCatalogues() {
        // Aliases: cookie stores form values (DINING., GIORNO., …),
        // data-terms may use the same label or a display name
        const aliases = {
            'CUCINA.': ['Cucina', 'CUCINA.'],
            'DINING.': ['Dining', 'DINING.'],
            'GIORNO.': ['Giorno', 'GIORNO.'],
            'NOTTE.': ['Notte', 'NOTTE.'],
            'SOFAS.': ['Sofas', 'SOFAS.'],
        }

        const normalize = (value) => String(value || '').trim().toLowerCase()

        const raw = getCookie('catalogue_interest')
        if (!raw) return

        let interestArray = []
        const trimmed = raw.trim()
        if (trimmed.startsWith('[')) {
            try {
                interestArray = JSON.parse(trimmed)
            } catch (e) {
                return
            }
        } else {
            interestArray = trimmed.split(',').map((s) => s.trim()).filter(Boolean)
        }

        if (!Array.isArray(interestArray) || interestArray.length === 0) {
            return
        }

        const allowed = new Set()
        interestArray.forEach((interest) => {
            allowed.add(normalize(interest))
            const list = aliases[interest] || [interest]
            list.forEach((term) => allowed.add(normalize(term)))
        })

        document.querySelectorAll('[data-terms]').forEach((catalogue) => {
            const term = normalize(catalogue.getAttribute('data-terms'))
            if (!allowed.has(term)) {
                catalogue.style.display = 'none'
                if (catalogue.parentNode) {
                    catalogue.parentNode.removeChild(catalogue)
                }
            }
        })

        // Hide "all catalogues" CTA when every form interest is already selected
        const allCatalogueKeys = ['DINING.', 'GIORNO.', 'NOTTE.', 'SOFAS.']
        const allActive = allCatalogueKeys.every((key) =>
            interestArray.some((interest) => normalize(interest) === normalize(key))
        )

        document.querySelectorAll('[data-condition="all-catalogues"]').forEach((catalogue) => {
            catalogue.style.display = allActive ? 'none' : 'block'
        })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}